// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({2239: "ActionToast",2733: "NftSecondaryMarketModal",2944: "RecentlyViewed",5338: "NftPdpZoomModal",8756: "EthereumWallet",9289: "ModelViewer",}[chunkId] || chunkId) + ".568.0.0." + {2239: "49a6476aa55630af",2733: "bb5c0a834a4835f2",2944: "7ae72097906143c4",5233: "20055c38f76f5da8",5338: "53ef6765ee10e1ec",8756: "409b6675697bba2e",9289: "4a966a8c71aed7f9",}[chunkId] + ".css"
}